import React from 'react';
import { DateTime } from 'luxon';
import { useStandardAreaInstallationTableQuery } from 'generated/graphql';

export type IData = {
  displayName: string;
  id: string;
  milestoneId: string;
  milestoneName: string;
  name: string;
  areaName: string;
  subAreaId: string;
  subAreaName: string;
  typeId: string;
  type: string;
};


export function useQuery() {
  const tuple = useStandardAreaInstallationTableQuery();

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.standardAreaInstallations?.map((node) => ({
        displayName: node?.displayName ?? '',
        id: node?.id ?? '',
        milestoneId: node.milestone?.id ?? '',
        milestoneName: node.milestone?.title ?? '',
        name: node?.name ?? '',
        subAreaId: node.subArea?.id ?? '',
        subAreaName: node.subArea?.displayName ?? '',
        areaName: node.area?.displayName ?? '',
        typeId: node.type?.id ?? '',
        type: node.type?.displayName ?? ''
      }
      )) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
